export class Tag {
    id: string;
    tagName: string;
    displayName: string;
    description: string;
    iconAssetUrl: string;
    parentTag: string;
    synonyms: string[];

    static create(data: unknown): Tag {
        return Object.assign(new Tag(), data);
    }
}
